import React from 'react';
import { Building2, Search, FileText, Shield, CheckCircle } from 'lucide-react';

const steps = [
  {
    title: 'Create Account',
    description: 'Set up your organization profile in minutes',
    icon: Building2,
  },
  {
    title: 'Discover Opportunities',
    description: 'Find relevant contracts with AI-powered matching',
    icon: Search,
  },
  {
    title: 'Manage Proposals',
    description: 'Create and track proposals with your team',
    icon: FileText,
  },
  {
    title: 'Ensure Compliance',
    description: 'Automated checks for perfect compliance',
    icon: Shield,
  },
  {
    title: 'Submit & Win',
    description: 'Higher success rates with data-driven insights',
    icon: CheckCircle,
  },
];

export function HowItWorks() {
  return (
    <div className="bg-gray-50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            How Bidzora Works
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Get started in minutes and transform your contracting process
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-2xl lg:max-w-none">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-5">
            {steps.map((step, index) => (
              <div key={step.title} className="relative text-center">
                {index < steps.length - 1 && (
                  <div className="absolute left-1/2 top-12 hidden h-0.5 w-full -translate-x-1/2 bg-gray-200 lg:block" />
                )}
                <div className="relative">
                  <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-indigo-600">
                    <step.icon className="h-12 w-12 text-white" />
                  </div>
                  <h3 className="mt-6 text-lg font-semibold text-gray-900">{step.title}</h3>
                  <p className="mt-2 text-sm text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}